import {
  Box,
  Column,
  Columns,
  Inline,
  Text,
} from 'braid-design-system';


import { DefaultLinkRenderer, type LinkRendererType } from '../LinkRenderer';

import { getLinks } from './links';

interface Props {
  linkRenderer?: LinkRendererType;
}

const Footer = ({
  linkRenderer: LinkRenderer = DefaultLinkRenderer,
}: Props) => {

  return (
    <Box
      component="footer"
      background="surface"
      padding={{ mobile: 'medium', tablet: 'gutter', desktop: 'gutter' }}
    >
      <Columns space={['large', 'gutter']} collapseBelow="tablet">
        <Column>
          <Inline space="large" collapseBelow="tablet">
            {
              getLinks('seek').map(
                ({
                  name,
                  rel,
                }) => (
                  <LinkRenderer
                    key={name}
                    rel={rel}
                    href={'google.com'}

                  >
                    {name}
                  </LinkRenderer>
                ),

            )}
          </Inline>
        </Column>
        <Column width="content">
          <Text size="small" tone="secondary">
            {'\u00A9Seek. All rights reserved.'
            }
          </Text>
        </Column>
      </Columns>
    </Box>
  );
};

export default Footer;
